import React from 'react';
import { useSelector } from 'react-redux';
import { GridWrapper } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/common/hooks';
import { navigationItemFromLink } from '@yme/components/Header/Menu/utils';
import { IndentWrapper } from '@yme/components/Separator';
import { SlideOutAnimationCard } from '@yme/molecules/cards';
import { getRTL } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { buildKey, buildStateParam, DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { DISCOVER_NEW_CONTAINER_PROPS, DISCOVER_NEW_DESK_COLUMNS } from './constants';
export function DiscoverNew(props) {
    const { isRemoveBottomIndent, cards } = props;
    const { isMobileView } = useWindowSize();
    const isRightToLeft = useSelector(getRTL);
    const cardsElements = cards.map((card) => {
        const { backgroundImage, button, description, subtitle, title } = card;
        const onClick = () => {
            setDigitalData(DigitalDataMutation.NAVIGATION, {
                pageSection: 'banner',
                navigationGroup: '',
                navigationItem: navigationItemFromLink(button.link),
            });
        };
        return (React.createElement(SlideOutAnimationCard, { key: buildKey(buildStateParam(), title), backgroundImage: backgroundImage, button: button, description: description, subtitle: subtitle, title: title, isRightToLeft: isRightToLeft, desktopGridCols: DISCOVER_NEW_DESK_COLUMNS, internalMargin: "32px", onClick: onClick }));
    });
    if (cards?.length === 0) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(GridWrapper, { containerProps: DISCOVER_NEW_CONTAINER_PROPS },
            React.createElement(FlexWrapper, { gap: isMobileView ? '32px' : '24px', flexDirection: isMobileView ? 'column' : 'row' }, cardsElements))));
}
DiscoverNew.displayName = 'DiscoverNew_AEMComponent';
